import { isAxiosError, isCancel } from 'axios';

/**
 * Detects Axios failures caused by `config.timeout` (client-side deadline).
 *
 * - Prefers `error.code` (`ECONNABORTED` / `ETIMEDOUT`) plus a timeout hint in `message`,
 *   which is more stable than matching a single English sentence across Axios versions.
 * - Returns false for user cancellation (`isCancel`) so aborts are not shown as timeouts.
 * - Keeps exact / regex message fallbacks for environments that only set `message`.
 */
export function isAxiosConfigTimeoutError(
  error: unknown,
  configuredTimeoutMs: number
): boolean {
  if (!isAxiosError(error) || isCancel(error)) {
    return false;
  }

  const msg = (error.message ?? '').trim();
  const lower = msg.toLowerCase();

  const { code } = error;
  if (code === 'ECONNABORTED' || code === 'ETIMEDOUT') {
    if (lower.includes('timeout')) {
      return true;
    }
  }

  if (msg === `timeout of ${configuredTimeoutMs}ms exceeded`) {
    return true;
  }
  return /^timeout of \d+ms exceeded$/i.test(msg);
}
